import React, { useEffect, useState } from 'react';
import styled, { withTheme } from 'styled-components';
import CssLoadingDots from '../../AlmeUtilities/Animations/CssLoadingDots';
const TypingMesssageContainer = styled.div `  
  display: flex;
  flex-direction: row-reverse;  
  align-content: flex-end;
  padding-top: 15px;
  flex-wrap: wrap-reverse;
`;
const Message = styled.div `
  font-size: ${props => props.theme.fontSizes.subText};
  text-align: right;
  color: #878787;
`;
export function isLiveChatOperatorTypingResponse(response) {
    return response.extensionData.MessageOrigin === "Operator-Typing";
}
const AlmeLiveChatOperatorTypingResponse = (props) => {
    var _a, _b;
    const [isTyping, setIsTyping] = useState(true);
    const operatorName = ((_a = props.response.extensionData.OperatorData) === null || _a === void 0 ? void 0 : _a.Name) || props.appConfig.liveChatControls.defaultOperatorName;
    const typingMessage = `${operatorName} ${props.appConfig.liveChatControls.typingMessageText}`;
    const handleTypingClose = () => {
        setIsTyping(false);
        props.markUsedResponse(props.response);
    };
    useEffect(() => {
        let timeoutId;
        if (isTyping) {
            timeoutId = window.setTimeout(() => handleTypingClose(), props.appConfig.liveChatControls.typingMessageDelay);
        }
        return () => { if (timeoutId)
            clearTimeout(timeoutId); };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isTyping]);
    if (!isTyping) {
        setIsTyping(true);
        return null;
    }
    return (React.createElement(TypingMesssageContainer, { id: 'alme-live-chat-typing' },
        CssLoadingDots((_b = props.theme) === null || _b === void 0 ? void 0 : _b.button.background),
        React.createElement(Message, null, typingMessage)));
};
export default withTheme(AlmeLiveChatOperatorTypingResponse);
